import JSEncrypt from "jsencrypt";

export const generateStateToken = () => {
  const randomBytes = new Uint8Array(32);
  window.crypto.getRandomValues(randomBytes);
  const hexString = Array.from(randomBytes)
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
  return hexString;
};

export const saveStateToken = (state) => {
  window.sessionStorage.setItem("oauth2-state-key", state);
};

export const removeStateToken = () => {
  window.sessionStorage.removeItem("oauth2-state-key");
};

export const encrypt = (data) => {
  const encrypt = new JSEncrypt();
  const publicKey = `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCulXSlMtgMt3yElGlKbgUldZo
  z7CkWnfpCZOtnlYhcawBbbQUKDppRzA/aG69IjuYGwUWfY1P2TPdV9UuPT34Ncd4
  OkRbP35Ydyj/RE715estrHafrLZkly/Tzcov1wNPdj0B+rJWy6Qtl2PGHFXKkk4W
  w4eQkdgModc9WLo7uQIDAQAB
  -----END PUBLIC KEY-----`;

  encrypt.setPublicKey(publicKey);
  const encrypted = encrypt.encrypt(data);

  return encrypted;
};

export const jsonParser = (_json) => {
  let json = {};

  try {
    json = JSON.parse(_json);

    if (json === null) {
      json = {};
    }
  } catch (error) {
    json = {};
  }

  return json;
};

export const getContentTypeByBundle = (bundle, contentTypes) => {
  return contentTypes.find((type) => type.bundle === bundle);
};


export const getTemplateByIdentity = (identity, templates) => {
  return templates.find((template) => template.identity_code === identity);
};
